import { render, staticRenderFns } from "./Dash-overview-one.vue?vue&type=template&id=5779deda"
import script from "./Dash-overview-one.vue?vue&type=script&lang=js"
export * from "./Dash-overview-one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports